'use strict';

require('../../style/index.less');

require('./index.less');


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/message/style/index.js
// module id = 90
// module chunks = 0